import HTTP from "@/_helpers/http";
import { COMMISSIONSETTINGS__API } from "@/_helpers/urls";
import { COMMISSIONSETTINGS__MUTATIONS } from "../mutation-types";
import { COMMISSIONSETTINGS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  levelCounts: 0,
  tierCounts: 0,
  accountTypes: null,
  currencyGroups: null,
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [COMMISSIONSETTINGS__MUTATIONS.COMMISSIONSETTINGS](state, data) {
    state.levelCounts = data.levelCounts;
    state.accountTypes = data.accountTypes;
    state.currencyGroups = data.currencyGroups;
    state.tierCounts = data.tierCounts;
  },
};
// Actions
const actions = {
  async [COMMISSIONSETTINGS__ACTIONS.COMMISSIONSETTINGS]({ commit, state }) {
    try {
      const response = await HTTP().get(
        COMMISSIONSETTINGS__API.COMMISSIONSETTINGS
      );

      if (response.status === 200) {
        commit(COMMISSIONSETTINGS__MUTATIONS.COMMISSIONSETTINGS, response.data);
      }
    } catch (error) {
      console.log(error);
    }
  },

  async [COMMISSIONSETTINGS__ACTIONS.CREATECOMMISSIONSETTINGS](
    { commit, state },
    parameter
  ) {
    try {
      const response = await HTTP().post(
        COMMISSIONSETTINGS__API.CREATECOMMISSIONSETTINGS,
        parameter
      );

      if (response.status === 200) {
        toast.success(response.data.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
